export function schoolNameForDocument(schoolKey, gender, fallback = "") {
  if (schoolKey === "abaq" && (gender === "male" || gender === "female")) {
    return `مدرسة عبق العلم العالمية - ${gender === "female" ? "بنات" : "بنين"}`;
  }
  return fallback;
}
